function Accordions() {
	this.init();
}

Accordions.prototype.init = function () {
	var self = this;
	$('.accordion:not(.accordion--disabled) > div .accordion-content').each(function() {
		$(this).accordion($(this).parent());
	});
	$('.filter-category__dropdown').each(function() {
		if ($(this).closest('.dropdown-content').siblings('.dropdown-top-bar').find('.filter-category__header-link').attr('href') == "#")
			$(this).accordion($(this).closest('.dropdown-content').siblings('.dropdown-top-bar').find('.filter-category__header'));
	});
	$('.filter-tags__dropdown').accordion('.filter-tags__header');
};

$.fn.accordion = function(parent) {
	var self = $(this);
	self.parent = $(parent);
	self.data('accordion', self);
	self.parent.find('> a[role=tab][href^="#"], > div[role=tab] svg, .accordion-toggle').click(function(e) {
		e.preventDefault();
		self.toggle();
	});
	self.parent.children('svg').click(function(e) {console.log('here');
		var that = this;
		e.preventDefault();
		self.toggle();
		setTimeout(function() {
			$(that).closest('.scroll-container').getNiceScroll().resize();
		}, 400);
	});

	self.toggle = function() {
		var self = this;
		if (!self.hasClass('-active')) {
			if (self.closest('.dropdown-group').find('.dropdown.-active').length) {
				self.closest('.dropdown-group').find('.dropdown.-active').each(function() {
					$(this).data('accordion').collapse();
				});
				clearTimeout(self.t2);
				clearTimeout(self.t4);
				clearTimeout(self.t5);
				self.t5 = setTimeout(function() {
					self.open();
				},400);
			} else {
				self.open();
			}
		} else {
			self.collapse();
		}
	};

	self.open = function() {
		var self = this;
		var outerHeight = self.outerHeight();
		clearTimeout(self.t2);
		clearTimeout(self.t4);
		clearTimeout(self.t5);
		self.parent.addClass('-active');
		if (self.hasClass('-animating')) {
			self.css({height:outerHeight});
		} else {
			self.addClass('-active');
			outerHeight = self.outerHeight();
			self.css({height:0});
			self.t1 = setTimeout(function() {
				self.addClass('-animating');
				self.css({height:outerHeight});
			},10);
		}
		self.find('.slickSlider').slick('setPosition');
		self.t2 = setTimeout(function() {
			clearTimeout(self.t2);
			self.attr('style','').removeClass('-animating');
		},500);
		// app.scroll.scrollTo(this.closest('section'));
	};

	self.collapse = function() {
		var self = this;
		var outerHeight = self.outerHeight();
		clearTimeout(self.t2);
		clearTimeout(self.t4);
		clearTimeout(self.t5);
		self.parent.removeClass('-active');
		if (self.hasClass('-animating')) {
			self.css({height:0});
		} else {
			self.css({height:outerHeight});
			self.t3 = setTimeout(function() {
				self.addClass('-animating');
				self.css({height:0});
			},10);
		}
		self.t4 = setTimeout(function() {
			clearTimeout(self.t4);
			self.attr('style','').removeClass('-active').removeClass('-animating');
		},500);
	};

	if (window.location.hash) {
		if ("#"+self.closest('.section--accordion').find('a[id]').first().attr('id') == window.location.hash)
			self.open();
	}
};